import React from "react"
import { useHistory, useParams } from "react-router-dom"
import styles from "./index.module.scss"
import XYCenterAlignedWindow from "../../components/XYCenterAlignedWindow"
import Loading from "../../components/Loading/Loading"
import services from "../../services"
import { paths } from "../../routes/paths"

const AcceptAdminInvitationPage = () => {
  const history = useHistory()
  const { admin_invite_token } = useParams()
  const [state, setState] = React.useState({
    isLoading: true,
    error: null,
    expired: false,
  })

  React.useEffect(() => {
    if (!admin_invite_token) {
      setState({
        isLoading: false,
        error: "Invalid invitation link",
        expired: false,
      })
      return
    }

    services.accountServices
      .acceptAdminInvitation(admin_invite_token)
      .then(({ data }) => {
        // Token is valid - redirect to choose password page
        history.push(
          `${paths.choosePassword.replace(":token", admin_invite_token)}?reason=invite_employee`
        )
      })
      .catch((error) => {
        const errorData = error?.response?.data || {}
        setState({
          isLoading: false,
          error: errorData.error || "Failed to validate invitation",
          expired: errorData.expired || false,
        })
      })
  }, [admin_invite_token, history])

  if (state.isLoading) {
    return (
      <div className={styles.pageWrap}>
        <XYCenterAlignedWindow>
          <Loading />
        </XYCenterAlignedWindow>
      </div>
    )
  }

  return (
    <div className={styles.pageWrap}>
      <XYCenterAlignedWindow>
        <div className={styles.errorContent}>
          <div className={styles.errorIcon}>⚠️</div>
          <h1 className={styles.errorTitle}>
            {state.expired ? "Invitation Expired" : "Invalid Invitation"}
          </h1>
          <p className={styles.errorMessage}>{state.error}</p>
          {state.expired && (
            <p className={styles.errorHelp}>
              Please contact the company administrator to request a new invitation.
            </p>
          )}
        </div>
      </XYCenterAlignedWindow>
    </div>
  )
}

export default AcceptAdminInvitationPage

